module.exports = __webpack_public_path__ + "static/media/La Luna e la Fisarmonica - Instrumental Version.9f133bcd.jpg";